import type { ReactNode } from 'react'

import { MarketAdBanner } from './MarketAdBanner'

type MarketPageHeaderProps = {
  title: string
  description?: string
  actions?: ReactNode
  showAd?: boolean
}

export const MarketPageHeader = ({ title, description, actions, showAd = false }: MarketPageHeaderProps) => (
  <div className="market-page__heading">
    <header className={`market-page__header${actions ? ' market-page__header--row' : ''}`}>
      <div>
        <h1>{title}</h1>
        {description ? <p className="market-muted">{description}</p> : null}
      </div>
      {actions ? <div className="market-inline-actions">{actions}</div> : null}
    </header>
    {showAd ? <MarketAdBanner /> : null}
  </div>
)
